/**
 * Script for Front Page
 *
 * @author Space-Time Inc.
 * @version 2022-10-21
 */

/**
 * Top Visual
 *
 * @author Space-Time Inc.
 * @version 2022-10-21
 */

 (() => {
	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

	class Balloon {
		#color = '';
		#dx    = 0;
		#dy    = 0;
		#speed = 0;
		#br    = 0;

		#dist  = 0;
		#r     = 0;

		constructor() {
			this.reset();
		}

		reset() {
			const cs = ['51, 88, 166', '229, 85, 99',  '240, 163, 75'];
			const n = Math.random();
			if (n < 0.33)      this.#color = cs[0];
			else if (n < 0.66) this.#color = cs[1];
			else               this.#color = cs[2];

			const rad   = Math.PI * 2 * Math.random();
			this.#dx    = Math.cos(rad);
			this.#dy    = Math.sin(rad);
			this.#speed = 50 + Math.random() * 950;
			this.#br    = Math.random() * 20;
			this.#dist  = 0;
			this.#r     = 0;
		}

		draw(ctx) {
			const x = this.#dx * this.#dist;
			const y = this.#dy * this.#dist;
			ctx.fillStyle = `rgba(${this.#color}, ${0.1 + 0.5 * this.#dist / 1000})`;
			ctx.beginPath();
			ctx.ellipse(x, y, this.#r, this.#r, 0, Math.PI * 2, false);
			ctx.fill();
		}

		update(t, limit) {
			this.#dist += this.#speed * t * 0.0004;
			this.#r = this.#br + this.#dist * 0.05;

			if (limit < this.#dist) {
				this.reset();
			}
		}
	}

	const can = document.getElementById('balloons');
	const ptv = document.querySelector('.part-top-visual');
	const img = ptv.querySelector('.images');

	if (!can || !ptv || !img) return;

	const ctx = can.getContext('2d');
	let ox, oy;
	let st;

	function fn() {
		const { x: px, y: py, width: pw, height: ph} = can.getBoundingClientRect();
		const { x: ix, y: iy, width: iw, height: ih } = img.getBoundingClientRect();

		can.style.opacity = 0;
		clearTimeout(st);
		st = setTimeout(() => {
			ox = (ix + iw * 0.5) - px;
			oy = (iy + ih * 0.5) - py;

			can.width  = pw;
			can.height = ph;
			for (const b of bs) b.reset();

			can.style.opacity = 1;
		}, 200);
	}
	addEventListener('resize', throttle(fn), false);
	setTimeout(fn, 100);

	const bs = [];
	for (let i = 0; i < 100; i += 1) bs.push(new Balloon);

	let prevT = 0;

	function draw(t) {
		if (0 === prevT) prevT = t;
		const dt = t - prevT;
		prevT = t;

		ctx.save();
		ctx.clearRect(0, 0, can.width, can.height);
		ctx.translate(ox, oy);
		for (const b of bs) b.draw(ctx);
		ctx.restore();
		for (const b of bs) b.update(dt, 1200);

		window.requestAnimationFrame(draw);
	}
	setTimeout(() => window.requestAnimationFrame(draw), 100);

})();

/**
 * Lists by Terms
 *
 * @author Space-Time Inc.
 */

(function () {
	const MAX_COUNT = 6;

	const root = document.querySelector('.part-dynamic-archive-filter');
	if (!root) return;
	const btns = root.querySelectorAll('button');

	const as = document.querySelectorAll('.part-dynamic-archive-filter-term-archive a');

	const items = document.querySelectorAll('.list-item-news > li');

	let current = 'all';

	for (const btn of btns) {
		btn.addEventListener('click', () => {
			current = btn.dataset.type;
			for (const b of btns) {
				if (btn === b) {
					b.classList.add('current');
				} else {
					b.classList.remove('current');
				}
			}
			for (const a of as) {
				if (a.dataset.type === current) {
					a.style.display = null;
				} else {
					a.style.display = 'none';
				}
			}
			set_item_visible(current, MAX_COUNT);
		});
	}

	function set_item_visible(f, count) {
		let i = 0;
		for (; i < items.length; i += 1) {
			const it = items[i];

			const v = ('all' === f) || (it.classList.contains(f));

			if (v) {
				it.style.display = '';
				count -= 1;
			} else {
				it.style.display = 'none';
			}
			if (count === 0) break;
		}
		i += 1;
		for (; i < items.length; i += 1) {
			items[i].style.display = 'none';
		}
	}

	btns[0].click();
})();


(() => {
	const root = document.querySelector(':root');
	const ptv  = document.querySelector('.part-top-visual');

	const phSh = document.querySelector('.site-header .sub');
	const phTv = document.querySelector('.page .tv-gn-wrapper');
	const gn   = document.querySelector('.site-header .sub .part-global-nav');

	if (!ptv || !phSh || !phTv || !gn) return;

	function fn() {
		setTimeout(() => {
			const top = window.scrollY;
			const bcr = ptv.getBoundingClientRect();
			root.style.setProperty('--top-visual-top',`${top + bcr.top}px`);
		}, 0);

		const { innerWidth: ww, innerHeight: wh } = window;
		if (ww < 600 && wh < 900) {
			phTv.appendChild(gn);
			root.classList.add('bottom-menu');
		} else {
			phSh.appendChild(gn);
			root.classList.remove('bottom-menu');
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();
